import { render, staticRenderFns } from "./WeOffer.vue?vue&type=template&id=453f97ca"
import script from "./WeOffer.vue?vue&type=script&lang=js"
export * from "./WeOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports